import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { comnUtils } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button } from "@/comn/components"; // 화면 구성 컴포넌트
import { useForm, useFetch, useResource, useAuth, useGrid, useStore, useToast, usePage } from "@/comn/hooks"; // hook
import { URLS, APIS, SG_RCPT_ERR_LIST, SF_RCPT_ERR_LIST_SRCH } from "./services/OsciRcptService"; // 서비스
import dayjs from "dayjs";

/*
 * Receipt Error List
 * !== 수납 오류 목록 ==!
 */
export const OSCI0402004Q = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */

    useResource({
        defaultSchema: [{ area: "coCd" }, { area: "cstmCd" }],
    });

    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003", "auth_osci0021"],
    }); // Page Unique identifier !== 화면 고유 식별자 ==!
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!
    let pgeTitle = "";

    if (menuId?.includes("menu_coli")) {
        pgeTitle = "T_RCPT_ERR_LST";
    } else if (menuId?.includes("menu_olmi")) {
        pgeTitle = "T_OIL_RCPT_ERR_LST";
    }

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Receipt Search !== 수납 검색 ==!
        rcptErrSrch: useForm({
            defaultSchema: SF_RCPT_ERR_LIST_SRCH,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Receipt List !== 수납 목록 ==!
        rcptErrList: useGrid({
            defaultSchema: SG_RCPT_ERR_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get Receipt Error List !== 수납 오류 목록 조회 ==!
        getRcptErrList: useFetch({
            api: (page = grid.rcptErrList.page) => {
                if (menuId?.includes("olmi")) {
                    form.rcptErrSrch.setValue("oilDclrYn", "Y");
                }
                let data = {
                    ...form.rcptErrSrch.getValues(),
                    orgCd: auth.get("orgCd"),
                };
                if (data.bllNo) {
                    data.bllNo = data.bllNo.trim(); // 앞뒤 공백 제거
                    // Bill No.가 "X-XXXX-XX-XXXXXXX-X"(bllMgmtId 마스크) 패턴이면 '-' 제거 후 조회
                    if (/^[A-Za-z0-9]-[A-Za-z0-9]{4}-[A-Za-z0-9]{2}-[A-Za-z0-9]{7}-[A-Za-z0-9]$/.test(data.bllNo)) {
                        data.bllNo = data.bllNo.replaceAll("-", "");
                    }
                }
                return APIS.getRcptErrList(data, page, grid.rcptErrList.size);
            },
            enabled: comnUtils.isEmpty(form.rcptErrSrch.errors) && form.rcptErrSrch.isSubmitted,
            key: [grid.rcptErrList.page, grid.rcptErrList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.rcptErrSrch.getValues(),
                    page: grid.rcptErrList.page,
                    size: grid.rcptErrList.size,
                });
            },
            onError: () => {},
            showToast: true,
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Get Receipt Error List !== 수납 오류 목록 조회 ==!
        getRcptErrList: (page: number = 0) => {
            form.rcptErrSrch.handleSubmit(
                () => {
                    // Validation Check !== 밸리데이션 체크 ==!
                    grid.rcptErrList.setPage(page);
                    fetch.getRcptErrList.fetch(page);
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },
    };

    const render = {
        grid_rcptErrList: {
            head: {},
            cell: {
                bllNo: (props: any) => {
                    const { rowValues } = props;
                    return (
                        <Layout direction="col" gap={1}>
                            <span style={{ color: "blue" }}>
                                <Link
                                    to={`${URLS.osci0402002q}/${rowValues.bllTpCd}-${rowValues.bllSysmCd}-${rowValues.bllYy}-${rowValues.bllSrno}-${rowValues.bllDgr}/collection/OSCI0402004Q`}
                                >{`${rowValues.bllNo}`}</Link>
                            </span>
                        </Layout>
                    );
                },
                tansadNo: (props: any) => {
                    const { rowValues } = props;

                    if (rowValues.reffKeyTpCd == "T") {
                        return (
                            <Layout direction="col" gap={1}>
                                <span style={{ color: "blue" }}>
                                    <Link
                                        to={`${URLS.osci0401003q}/${rowValues.reffKeyNo1}-${rowValues.reffKeyNo2}-${rowValues.reffKeyNo3}/OSCI0402004Q`}
                                    >{`${rowValues.reffKeyNo1}-${rowValues.reffKeyNo2}-${rowValues.reffKeyNo3}`}</Link>
                                </span>
                            </Layout>
                        );
                    } else if (rowValues.tansadNo != null && rowValues.tansadNo.length > 6) {
                        const reffKeyNo1 = rowValues.tansadNo.substring(0, 4);
                        const reffKeyNo2 = rowValues.tansadNo.substring(4, 6);
                        const reffKeyNo3 = rowValues.tansadNo.substring(6);

                        console.log(`${reffKeyNo1}-${reffKeyNo2}-${reffKeyNo3}`);
                        return (
                            <Layout direction="col" gap={1}>
                                <span style={{ color: "blue" }}>
                                    <Link
                                        to={`${URLS.osci0401003q}/${reffKeyNo1}-${reffKeyNo2}-${reffKeyNo3}`}
                                    >{`${reffKeyNo1}-${reffKeyNo2}-${reffKeyNo3}`}</Link>
                                </span>
                            </Layout>
                        );
                    }
                },
            },
            edit: {},
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        handler.getRcptErrList(pgeStore?.page);
    }, []);

    return (
        <Page title={t(pgeTitle)}>
            <form>
                <Group>
                    <Group.Body>
                        <Layout direction="row">
                            <Layout.Left size={6}>{}</Layout.Left>
                            <Layout.Right>{}</Layout.Right>
                        </Layout>
                        <Group.Section>
                            <Group.Row>
                                {/* Receipt Custom Office Code !== 고지서 세관 코드 ==!  */}
                                <Group.Control {...form.rcptErrSrch.schema.cstmOfceCd}></Group.Control>
                                {/* TANSAD Number !== TANSAD 번호 ==!  */}
                                <Group.Control {...form.rcptErrSrch.schema.tansadNo}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                {/* Error Receive Date !== 오류 수신 일자 ==!  */}
                                <Group.Control {...form.rcptErrSrch.schema.errRcveDtmRnge}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.rcptErrSrch.schema.bllNo}></Group.Control>
                            </Group.Row>
                        </Group.Section>

                        <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    role="reset"
                                    onClick={() => {
                                        form.rcptErrSrch.reset();
                                    }}
                                ></Button>
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    role="search"
                                    onClick={() => {
                                        handler.getRcptErrList();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout>
                    </Group.Body>
                </Group>
            </form>

            <Group>
                <Group.Body>
                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="excelDown"
                                onClick={() => {
                                    grid.rcptErrList.exportExcel({
                                        /* 다운로드 엑셀 파일명 (확장자 없이), 기본값 Export(년월일시분초) */
                                        excelName: dayjs().format("YYYY-MM-DD HH:mm:ss") + "_" + pgeUid,
                                        /* 다운로드 엑셀 시트명 , 기본값 Sheet */
                                        sheetName: "Sheet Name",
                                    });
                                }}
                            ></Button>
                        </Layout.Left>
                    </Layout>
                    <Grid
                        {...grid.rcptErrList.grid}
                        data={fetch.getRcptErrList.data?.rcptErrList}
                        render={render.grid_rcptErrList}
                    />
                </Group.Body>
            </Group>
            <Layout direction="row">
                <Layout.Left></Layout.Left>
            </Layout>
        </Page>
    );
};
